import { render } from "./GpsCommand.vue?vue&type=template&id=58e17b96"
import script from "./GpsCommand.vue?vue&type=script&lang=js"
export * from "./GpsCommand.vue?vue&type=script&lang=js"
script.render = render

export default script